import React from "react";
import { Text, View, StyleSheet, Font, Image } from "@react-pdf/renderer";
import { borderColor, styles } from "../GenericPdf/style";
import { price_in_words } from "../../../../utils/commonFunctions";

type SignatureType = {
  file_name: string;
  file_type: string;
  file_url: string;
};

type AppProps = {
  items: any;
  currencySign: string | undefined;
  currencyShortForm: string | undefined;
  signature: SignatureType | null | any;
};

let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
let blobToken = process.env.REACT_APP_BLOB_TOEKN;

const InvoiceTableFooter = ({
  items,
  currencySign,
  currencyShortForm,
  signature,
}: AppProps) => {
  return (
    <View>
      <View style={{ ...styles.row }}>
        <View style={{ height: "100%", flexWrap: "wrap", width: "70%" }}>
          <Text
            style={{
              ...styles.tableFooter,
              flexWrap: "wrap",
              textAlign: "left",
            }}
          >
            {items?.invoice_value
              ? `${price_in_words(
                  items?.invoice_value,
                  currencyShortForm ? currencyShortForm : ""
                )}`
              : null}
          </Text>
        </View>

        <View
          style={{
            flexDirection: "row",
            width: "30%",
            height: "100%",
            justifyContent: "space-between",
            alignItems: "flex-end",
            borderLeft: `1px solid ${borderColor}`,
          }}
        >
          <Text style={{ ...styles.tableFooter, marginLeft: "10px" }}>
            Invoice Value ({currencyShortForm})
          </Text>
          <Text
            style={{
              ...styles.currencyFont,
              padding: "2px",
              marginRight: "10px",
            }}
          >
            {currencySign}{" "}
            {Number.parseFloat(items?.invoice_value).toFixed(2)
              ? Number.parseFloat(items?.invoice_value).toFixed(2)
              : 0}
          </Text>
        </View>
      </View>

      {/* comment for future use  */}
      {/* <View style={{...styles.row,width:"100%",justifyContent:"flex-end"}}>
        <View style={{ flexDirection: "row", width:"30%",justifyContent: "space-between" ,alignItems:"flex-end",borderLeft:`1px solid ${borderColor}`}}>
        <Text style={{ ...styles.tableFooter, marginLeft: "10px" }}>TDS</Text>
        <Text  style={{ ...styles.tableFooter, marginLeft: "10px",marginRight:"10px" }}>{items?.tds ? items?.tds : 0}</Text>
        </View>
        
      </View>

      <View style={{...styles.row,width:"100%",justifyContent:"flex-end"}}>
        <View style={{ flexDirection: "row", width:"30%",justifyContent: "space-between" ,alignItems:"flex-end",borderLeft:`1px solid ${borderColor}`}}>
        <Text style={{ ...styles.tableFooter, marginLeft: "10px" }}>Net Amount</Text>
        <Text style={{ ...styles.tableFooter, marginLeft: "10px" ,marginRight:"10px"}}>{items?.net_amount ? items?.net_amount : 0}</Text>
        </View>
      </View> */}

      <View
        style={{ ...styles.row, width: "100%", justifyContent: "flex-end" }}
      >
        <View
          style={{
            justifyContent: "space-between",
            width: "30%",
            height: "60px",
            borderLeft: `1px solid ${borderColor}`,
          }}
        >
          {signature?.file_url ? (
            <View style={{ ...styles.tableFooter }}>
              <Image
                src={`${blobBaseUrl}${signature?.file_url}?${blobToken}`}
              />
            </View>
          ) : (
            <Text style={{ ...styles.tableFooter }}></Text>
          )}
          <View>
            <Text
              style={{
                ...styles.for,
                borderTop: `1px solid ${borderColor}`,
                paddingTop: "2px",
                paddingLeft: "2px",
                flexWrap: "wrap",
                textAlign: "center",
              }}
            >
              For {items?.primary_details?.bill_from?.trade_name}
            </Text>
          </View>
        </View>
      </View>

      {items?.payment_details?.length ? (
        <View style={{ ...styles.row }}>
          <View
            style={{
              ...styles.flexCenter,
              marginTop: "5px",
              padding: "5px",
              flexWrap: "wrap",
            }}
            break
          >
            <Text style={{ ...styles.sub_header }}>Note : </Text>
            <Text style={{ ...styles.text }}>
              {items?.payment_details[0]?.narration}
            </Text>
          </View>
        </View>
      ) : null}
    </View>
  );
};

export default InvoiceTableFooter;
